import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";

import { formatDate } from "../../components/utils/functions";
import { GET_HEALTH_FORM } from "../../Graphql/queries/queryGetHealthForm";
import { MUTATION_UPDATE_STATUS_HEALTH } from "../../Graphql/mutations/mutationUpdateStatusHealth";
import { useToastError } from "../../Hooks/useToastError";
import { useToastLoading } from "../../Hooks/useToastLoading";
import { useToastSuccessful } from "../../Hooks/useToastSuccessful";
import HeaderMain from "../../components/header/headerMain";
import ModalSetStatus from "../../Modals/ModalSetStatus";
import { LoadingScreen } from "../../components/StatusScreens/LoadingScreen";
import { GET_SUPERVISION_FORM } from "../../Graphql/queries/queryGetAdultSupervisionForm";
import ModalSupervision from "../../Modals/ModalSupervision";
import ModalNoCapacityPay from "../../Modals/ModalNoCapacityPay";
import IconFileUpload from "../../components/Icons/IconFileUpload";
import PrimaryNormal from "../../components/buttons/PrimaryNormal";

import { styleButtonNews } from "../../styles/PageStyles/Health/stylesRegistersHealth";
import {
  Back,
  ContainerDad,
  ContainerField,
  ContainerGlobal,
  ContainerTransparent,
  OptionSupervision,
  TextAffiliateStatus,
  TextInfo,
  TextNoPay,
  TextPendingStatus,
  TextUnaffiliatedStatus,
  Title,
} from "../../styles/PageStyles/Health/stylesDetailRegister";
import ModalNews from "../../Modals/ModalNews";

const DetailRegister = () => {
  const navigate = useNavigate();
  const location = useLocation();
  /* eslint-disable */
  const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
  const RESOURCE = process.env.REACT_APP_RESOURCE;
  /* eslint-enable */
  const { item } = location.state;
  const [modalStatus, setModalStatus] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalNoCapacityPay, setModalNoCapacityPay] = useState(false);
  const [modalNews, setModalNews] = useState(false);
  const [statusNext, setStatusNext] = useState(null);
  const [showNextStatus, setShowNextStatus] = useState(false);

  const toastSuccessful = useToastSuccessful();

  const { refetch } = useQuery(GET_HEALTH_FORM, {
    variables: {
      affiliated: null,
      noAffiliate: "NOT_AFFILIATE",
      pending: "PENDING_REQUEST",
    },
  });

  const [getSupervisionForm, { error, data, loading }] = useLazyQuery(GET_SUPERVISION_FORM);

  const [updateStatusHealth, { error: errorUpd, loading: loadingUpd }] = useMutation(MUTATION_UPDATE_STATUS_HEALTH, {
    onCompleted: () => {
      setShowNextStatus(true);
      setTimeout(() => {
        toastSuccessful("Actualizado con éxito.");
        refetch();
      }, 500);
    },
    onError: (err) => console.error(err),
  });

  useToastError(error, errorUpd);
  useToastLoading(loadingUpd, "Actualizando...");

  const goBack = () => {
    navigate(-1);
  };

  const getStatus = () => {
    if (showNextStatus) {
      if (statusNext === "AFFILIATE") {
        return <TextAffiliateStatus>Afiliado(a)</TextAffiliateStatus>;
      } else if (statusNext === "PENDING_REQUEST") {
        return <TextPendingStatus>Pendiente</TextPendingStatus>;
      } else {
        return <TextUnaffiliatedStatus>No afiliado(a)</TextUnaffiliatedStatus>;
      }
    } else {
      if (item.isAffiliated === "AFFILIATE") {
        return <TextAffiliateStatus>Afiliado(a)</TextAffiliateStatus>;
      } else if (item.isAffiliated === "PENDING_REQUEST") {
        return <TextPendingStatus>Pendiente</TextPendingStatus>;
      } else {
        return <TextUnaffiliatedStatus>No afiliado(a)</TextUnaffiliatedStatus>;
      }
    }
  };

  const updateForm = (status) => {
    setStatusNext(status);
    console.log({
      healthId: item.id,
      isAffiliated: status,
    });
    updateStatusHealth({
      variables: {
        healthId: item.id,
        isAffiliated: status,
      },
    });
  };

  const getStorage = () => {
    if (ENVIRONMENT === "production") {
      return `https://${RESOURCE}.blob.core.windows.net/integracion-migrante-documents/${item.file}`;
    } else {
      return `https://${RESOURCE}.blob.core.windows.net/${ENVIRONMENT}-integracion-migrante-documents/${item.file}`;
    }
  };

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <ContainerGlobal>
      <HeaderMain />
      <ContainerTransparent>
        <Back onClick={goBack}>Volver</Back>
        <Title>Detalle de registro</Title>
        <ContainerDad>
          <ContainerField style={{ cursor: "pointer" }} onClick={() => setModalStatus(!modalStatus)}>
            <TextInfo>Estado:</TextInfo>
            <p>{getStatus()}</p>
            <ModalSetStatus modalOpen={modalStatus} setModalOpen={setModalStatus} updateForm={updateForm} />
          </ContainerField>
          <ContainerField>
            <TextInfo>Fecha de inscripción:</TextInfo>
            <p>{formatDate(item?.created)}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Nombre:</TextInfo>
            <p>{item.firstName}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Apellidos:</TextInfo>
            <p>{item.lastName}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Correo electrónico:</TextInfo>
            <p>{item.email}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Fecha de nacimiento:</TextInfo>
            <p>{formatDate(item.birthDate)}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Sexo:</TextInfo>
            <p>{item.gender === "MALE" ? "MASCULINO" : "FEMENINO"}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>tipo de documento:</TextInfo>
            <p>{item.documentType.name}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Numero de documento:</TextInfo>
            <p>{item.documentNumber}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Fecha de expedición:</TextInfo>
            <p>{formatDate(item.documentExpirationDate)}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Departamento:</TextInfo>
            <p>{item.state.name}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Municipio/Cuidad:</TextInfo>
            <p>{item.city.name}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Barrio/Dirección:</TextInfo>
            <p>{item.neighborhood}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>E.P.S:</TextInfo>
            <p>{item.ePS.name}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Contacto:</TextInfo>
            <p>{item.phoneNumber}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Contacto 2:</TextInfo>
            <p>{item.secondaryPhoneNumber}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>WhatsApp:</TextInfo>
            <p>{item.optionalPhoneNumber}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Cabeza de familia:</TextInfo>
            <p>{item.dependentChildren ? "Si" : "No"}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Representante de menor:</TextInfo>
            <p>
              {item.isAdultSupervision ? (
                <OptionSupervision
                  onClick={() => {
                    getSupervisionForm({
                      variables: {
                        healthId: item.id,
                      },
                    });
                    setModalVisible(true);
                  }}
                >
                  Si
                </OptionSupervision>
              ) : (
                "No"
              )}
              <ModalSupervision
                modalVisible={modalVisible}
                setModalVisible={setModalVisible}
                info={data?.getAdultSupervisionForm}
              />
            </p>
          </ContainerField>
          <ContainerField>
            <TextInfo>No capacidad de pago:</TextInfo>
            <TextNoPay onClick={() => setModalNoCapacityPay(true)}>Aceptado</TextNoPay>
            <ModalNoCapacityPay
              createdDate={item.created}
              firstName={item.firstName}
              modalVisible={modalNoCapacityPay}
              setModalVisible={setModalNoCapacityPay}
            />
          </ContainerField>
          <ContainerField>
            <TextInfo>Ver archivo adjunto:</TextInfo>
            <a href={getStorage()}>
              <IconFileUpload file={item.file} />
            </a>
          </ContainerField>
          <ContainerField>
            <TextInfo>Novedades:</TextInfo>
            <PrimaryNormal title="Novedades" style={styleButtonNews} onClick={() => setModalNews(true)} />
            <ModalNews modalOpen={modalNews} setModalOpen={setModalNews} healthId={item.id} />
          </ContainerField>
        </ContainerDad>
      </ContainerTransparent>
    </ContainerGlobal>
  );
};

export default DetailRegister;
